import { PassportUserManagementServiceClientConfigFactory } from "@amzn/coral-config_passport-user-management-service";
import { PASSPORT_URL_PREFIXES, PUMS_CORAL_CONFIG, PUMS_PASSPORT_CORAL_CONFIG, URL_PREFIXES, URL_PREFIXES_DEPRECATED } from "./endpointConfig";
var getEnv = function() {
    var url = window.location.href;
    var env;
    if (url.includes(URL_PREFIXES_DEPRECATED.BETA_URL_PREFIX)) {
        env = PUMS_CORAL_CONFIG.BETA_CONFIG_DEPRECATED;
    } else if (url.includes(URL_PREFIXES_DEPRECATED.GAMMA_URL_PREFIX)) {
        env = PUMS_CORAL_CONFIG.GAMMA_CONFIG_DEPRECATED;
    } else if (url.includes(URL_PREFIXES_DEPRECATED.PROD_URL_PREFIX)) {
        env = PUMS_CORAL_CONFIG.PROD_CONFIG_DEPRECATED;
    } else if (url.includes(URL_PREFIXES.BETA_URL_PREFIX)) {
        env = PUMS_CORAL_CONFIG.BETA_CONFIG;
    } else if (url.includes(URL_PREFIXES.GAMMA_URL_PREFIX)) {
        env = PUMS_CORAL_CONFIG.GAMMA_CONFIG;
    } else if (url.includes(URL_PREFIXES.PROD_URL_PREFIX)) {
        env = PUMS_CORAL_CONFIG.PROD_CONFIG;
    } else if (url.includes(PASSPORT_URL_PREFIXES.BETA_URL_PREFIX)) {
        env = PUMS_PASSPORT_CORAL_CONFIG.BETA_CONFIG;
    } else if (url.includes(PASSPORT_URL_PREFIXES.GAMMA_URL_PREFIX)) {
        env = PUMS_PASSPORT_CORAL_CONFIG.GAMMA_CONFIG;
    } else if (url.includes(PASSPORT_URL_PREFIXES.PROD_URL_PREFIX)) {
        env = PUMS_PASSPORT_CORAL_CONFIG.PROD_CONFIG;
    } else {
        env = PUMS_CORAL_CONFIG.LOCAL_DEV;
    }
    return env;
};
export var getAuthEnvUrlForPassport = function() {
    var ref, ref1;
    var url = window.location.href;
    var env;
    if (url.includes(PASSPORT_URL_PREFIXES.BETA_URL_PREFIX)) {
        env = PUMS_PASSPORT_CORAL_CONFIG.BETA_CONFIG;
    } else if (url.includes(PASSPORT_URL_PREFIXES.GAMMA_URL_PREFIX)) {
        env = PUMS_PASSPORT_CORAL_CONFIG.GAMMA_CONFIG;
    } else if (url.includes(PASSPORT_URL_PREFIXES.PROD_URL_PREFIX)) {
        env = PUMS_PASSPORT_CORAL_CONFIG.PROD_CONFIG;
    } else {
        env = PUMS_PASSPORT_CORAL_CONFIG.BETA_CONFIG;
    }
    var requiredUrl = (ref = PassportUserManagementServiceClientConfigFactory.getConfigForQualifier(env)) === null || ref === void 0 ? void 0 : (ref1 = ref.httpEndpoint) === null || ref1 === void 0 ? void 0 : ref1.url;
    return requiredUrl;
};
var isProd = function() {
    var env = getEnv();
    return env === PUMS_CORAL_CONFIG.PROD_CONFIG;
};
var envHelper = {
    getEnv: getEnv,
    isProd: isProd
};
export default envHelper;

//# sourceMappingURL=index.js.map